import { useCompaniesContext } from 'company/context'
import { MemberChangesScreenProps } from 'home/stack/types'
import { useUserChanges } from 'management_team/queries/changes'
import { StatusBoundary } from 'shared/components/status_boundary'
import { MemberChangesView } from './views'

export function MemberChangesScreen({
  navigation,
  route,
}: MemberChangesScreenProps) {
  const { activeCompany } = useCompaniesContext()
  const userChangesQuery = useUserChanges(activeCompany?.id)
  return (
    <StatusBoundary
      isLoading={userChangesQuery.isLoading}
      error={userChangesQuery.error}
    >
      <MemberChangesView userChanges={userChangesQuery.data ?? []} />
    </StatusBoundary>
  )
}
